import pythonApiClient from './pythonBaseApi';

/**
 * Servicio para gestión de homologación de Excel
 * Maneja todas las operaciones CRUD relacionadas con parametría de homologación
 */
export const homologacionExcelApi = {
  /**
   * Obtiene todas las homologaciones
   * @param {boolean} activoOnly - Solo homologaciones activas (opcional)
   * @returns {Promise} - Respuesta de la API
   */
  getAll: (activoOnly = false) => {
    const params = activoOnly ? '?activo_only=true' : '';
    return pythonApiClient.get(`/mantenimientos/carga-masiva-externa-atenciones-homologacion-excel${params}`);
  },

  /**
   * Obtiene una homologación por ID
   * @param {number} id - ID de la homologación
   * @returns {Promise} - Respuesta de la API
   */
  getById: (id) => {
    return pythonApiClient.get(`/mantenimientos/carga-masiva-externa-atenciones-homologacion-excel/${id}`);
  },

  /**
   * Crea una nueva homologación
   * @param {Object} data - Datos de la homologación
   * @param {string} data.descripcion - Descripción del tipo de homologación (obligatorio)
   * @param {boolean} data.activo - Estado activo (default: true)
   * @param {Object} data.detalle - Detalle con mapeo de columnas
   * @param {number} data.detalle.columna_fecha_atencion - Número de columna para fecha (1-indexed)
   * @param {number} data.detalle.columna_tipo_servicio - Número de columna para tipo de servicio (1-indexed)
   * @param {number} data.detalle.columna_numero_documento - Número de columna para número de documento (1-indexed)
   * @returns {Promise} - Respuesta de la API
   */
  create: (data) => {
    return pythonApiClient.post('/mantenimientos/carga-masiva-externa-atenciones-homologacion-excel', data);
  },

  /**
   * Actualiza una homologación existente
   * @param {number} id - ID de la homologación
   * @param {Object} data - Datos actualizados de la homologación
   * @returns {Promise} - Respuesta de la API
   */
  update: (id, data) => {
    return pythonApiClient.put(`/mantenimientos/carga-masiva-externa-atenciones-homologacion-excel/${id}`, data);
  },

  /**
   * Elimina una homologación
   * @param {number} id - ID de la homologación
   * @returns {Promise} - Respuesta de la API
   */
  delete: (id) => {
    return pythonApiClient.delete(`/mantenimientos/carga-masiva-externa-atenciones-homologacion-excel/${id}`);
  }
};

export default homologacionExcelApi;
